
var vouchers = angular.module('vouchers', ['classy', 'standardCudFactory', 'firstRun', 'printVoucher']);
